var _defineProperty = require("D:\\Paymob\\Projects\\Dashboard\\accept_dashboard\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/defineProperty");
var _objectSpread = require("D:\\Paymob\\Projects\\Dashboard\\accept_dashboard\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/objectSpread");
var _toConsumableArray = require("D:\\Paymob\\Projects\\Dashboard\\accept_dashboard\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/toConsumableArray");
!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports.ls = e() : t.ls = e();
}(this, function () {
  return function () {
    "use strict";

    var t = {
        d: function d(e, r) {
          for (var n in r) t.o(r, n) && !t.o(e, n) && Object.defineProperty(e, n, {
            enumerable: !0,
            get: r[n]
          });
        },
        o: function o(t, e) {
          return Object.prototype.hasOwnProperty.call(t, e);
        }
      },
      e = {};
    t.d(e, {
      default: function _default() {
        return u;
      }
    });
    var r = function r() {},
      n = function n(t) {
        return null !== t && "Object" === t.constructor.name;
      };
    var o;
    var c = function c() {
        if (void 0 !== o) return o;
        o = !0;
        try {
          localStorage || (o = !1);
        } catch (_unused) {
          o = !1;
        }
        return s(), o;
      },
      l = String.fromCharCode(0),
      a = function a(t, e) {
        var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
        return r ? _toConsumableArray(JSON.stringify(t)).map(function (t) {
          return String.fromCharCode(t.charCodeAt(0) + e);
        }).join("") : JSON.parse(_toConsumableArray(t).map(function (t) {
          return String.fromCharCode(t.charCodeAt(0) - e);
        }).join(""));
      },
      p = {
        ttl: null,
        encrypt: !1,
        encrypter: a,
        decrypter: function decrypter(t, e) {
          return a(t, e, !1);
        },
        secret: 75
      },
      s = function s() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
        if (!c()) return !1;
        Object.keys(localStorage).forEach(function (e) {
          var r = localStorage.getItem(e);
          if (!r) return;
          var o;
          try {
            o = JSON.parse(r);
          } catch (_unused2) {
            return;
          }
          n(o) && l in o && (Date.now() > o.ttl || t) && localStorage.removeItem(e);
        });
      },
      u = {
        config: p,
        set: function set(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          if (!c()) return !1;
          var o = _objectSpread({}, p, n, {
            encrypt: !1 !== n.encrypt && (n.encrypt || p.encrypt),
            ttl: null === n.ttl ? null : n.ttl || p.ttl
          });
          try {
            var _ref;
            var _n = o.ttl && !isNaN(o.ttl) && o.ttl > 0;
            var _c = _n ? (_ref = {}, _defineProperty(_ref, l, e), _defineProperty(_ref, "ttl", Date.now() + 1e3 * o.ttl), _ref) : e;
            o.encrypt && (_n ? _c[l] = (o.encrypter || r)(_c[l], o.secret) : _c = (o.encrypter || r)(_c, o.secret)), localStorage.setItem(t, JSON.stringify(_c));
          } catch (_unused3) {
            return !1;
          }
        },
        get: function get(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          if (!c()) return null;
          var o = localStorage.getItem(t);
          if (!o) return null;
          var a = _objectSpread({}, p, e, {
            encrypt: !1 !== e.encrypt && (e.encrypt || p.encrypt),
            ttl: null === e.ttl ? null : e.ttl || p.ttl
          });
          var s = JSON.parse(o);
          var u = n(s) && l in s;
          if (a.decrypt || a.encrypt) try {
            u ? s[l] = (a.decrypter || r)(s[l], a.secret) : s = (a.decrypter || r)(s, a.secret);
          } catch (_unused4) {}
          return u ? Date.now() > s.ttl ? (localStorage.removeItem(t), null) : s[l] : s;
        },
        flush: s,
        clear: function clear() {
          if (!c()) return !1;
          localStorage.clear();
        },
        remove: function remove(t) {
          if (!c()) return !1;
          localStorage.removeItem(t);
        }
      };
    return e.default;
  }();
});